import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { analyticsPath, apiClient } from '@/lib/api-client';
import { adaptUserGeography, type ApiUserGeography } from '@/lib/analytics-adapters';
import type { UserGeography } from '@/types/analytics';

import { analyticsKeys } from './analytics-keys';

export function useUserGeography(): UseQueryResult<UserGeography, Error> {
  return useQuery({
    queryKey: analyticsKeys.userGeography(),
    queryFn: async ({ signal }) =>
      adaptUserGeography(
        await apiClient.get<ApiUserGeography>(analyticsPath('/users/geography'), signal),
      ),
    refetchInterval: 30_000,
  });
}
